module.exports = __webpack_public_path__ + "e1e24db45c2535ba2ff6820e8e86b27a.mp4";